<template>
	<div class="pages">
		<section class="fx filter-wapper">
			<div class="fx fx-wrap fx-fill">
				<div class="fx fx-wrap">
					<!--<el-date-picker v-model="filterTime" type="daterange" align="left" placeholder="选择日期范围(默认所有)" :picker-options="pickerOptions" @change="initData">
					</el-date-picker>-->
                    <el-date-picker
                            v-model="stasticDate"
                            type="daterange"
                            align="left"
                            placeholder="选择日期范围"
                            :picker-options="pickerOptions"
                            @change="handleDatePicker">
                    </el-date-picker>
                    <z-select :options="shopItems" class="w150" v-model="params.shopId" @handleChange="handleOffset(0)"></z-select>
                    <z-select :options="payTypeItems" class="w150" v-model="params.payType" @handleChange="handleOffset(0)"></z-select>
                    <a class="z-btn z-btn-primary b-r-3" @click="handleExcelData">导出</a>
				</div>
			</div>
		</section>
		<!--列表-->
		<div id="list">
			<z-table :offset="params.offset" :count="params.count" :total-count="list.item_total" @handleOffset="handleOffset">
				<th slot="columns" v-for="item in columns">{{item}}</th>
				<tr slot="datasource" v-for="(item, index) in list.list || []">
					<td>{{item.day}}</td>
					<td>
						<p>交易金额：{{item.wechatCount | filterMoney}}</p>
						<p>交易手续费率：{{userInfo.rate}}</p>
						<p>交易手续费：{{item.wechatCount*userInfo.rate | filterMoney}}</p>
						<p>结算金额：{{(item.wechatCount - (item.wechatCount/100)*userInfo.rate) | filterMoney}}</p>
					</td>
					<td>
						<p>交易金额：{{item.alipayCount | filterMoney}}</p>
						<p>交易手续费率：{{userInfo.rate}}</p>
						<p>交易手续费：{{item.alipayCount*userInfo.rate | filterMoney}}</p>
						<p>结算金额：{{(item.alipayCount - (item.alipayCount/100)*userInfo.rate) | filterMoney}}</p>
					</td>
					<td>
						<p>交易金额：{{item.unionPayCount | filterMoney}}</p>
						<p>交易手续费率：{{userInfo.car_rate}}</p>
						<p>交易手续费：{{item.unionPayCount*userInfo.car_rate | filterMoney}}</p>
						<p>结算金额：{{(item.unionPayCount - (item.unionPayCount/100)*userInfo.car_rate) | filterMoney}}</p>
					</td>
					<td>{{item.count | filterMoney}}</td>
					<td>{{(item.count - (item.wechatCount*userInfo.rate + item.alipayCount*userInfo.rate + item.unionPayCount*userInfo.car_rate)) | filterMoney}}</td>
					<td>{{(item.wechatCount*userInfo.rate + item.alipayCount*userInfo.rate + item.unionPayCount*userInfo.car_rate) | filterMoney}}</td>
					<td>T+{{userInfo.settlement_cycle}}</td>
				</tr>
			</z-table>
		</div>
	</div>
</template>
<script>
	import {
		mapActions,
		mapState
	} from 'vuex';
	export default {
		name: 'FinanceList',
		components: {},
		data() {
			return {
				columns: ['报表日期', '微信', '支付宝', '刷卡', '总交易金额(元)', '结算金额(元)','总交易手续费','结算周期'],
				params: {
					offset: 0,//分页偏移量
					count: 10, //每页多少条
					startDate:null,
					endDate:null,
//					search: '',//查询字符串
                    shopId: '',//门店ID
                    payType: '',//支付渠道
				},
				stasticDate:[null,null],
				pickerOptions: {
					shortcuts: [{
						text: '最近7天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近15天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近30天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}]
				},
				shopItems: [],
				payTypeItems: [{
					value: '',
                    text: '请选择支付渠道'
                }, {
					value: 'Wechat',
					text: '微信'
				}, {
					value: 'Alipay',
					text: '支付宝'
				}, {
					value: 'UnionPay',
					text: '刷卡'
				}]
			}
		},
		async mounted() {
			this.initData();
			let shopItems = await this.getShopItemsById();
			shopItems.unshift({value: '', text: '请选择门店'});
			this.shopItems = shopItems;
		},
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				list: state => state.finance.list,
				userInfo: state => state.users.userInfo,
                // shopItems: state.shops.itemList
			})
		},
		/*
		 * 事件处理
		 */
		methods: {
			//处理分页
			handleOffset(offset = 0) {
				this.params.offset = offset;
				this.initData();
			},
			handleDatePicker(){
				this.params.offset = 0;
				this.params.startDate = this.stasticDate[0]
				this.params.endDate = this.stasticDate[1]
				this.initData();
			},
			//获取对账列表
			async initData() {
				await this.getFinanceList(this.params)
			},
            //导出excel
			async handleExcelData() {
				window.open(`http://${window.location.host}/api/getDataToExcel?offset=${this.params.offset}&count=${this.params.count}&shopId=${this.params.shopId}&payType=${this.params.payType}`);
            },
			...mapActions(['getFinanceList', 'getShopItemsById', 'getDataToExcel']),
		}
	}
</script>

<style lang="scss" scoped>
	@import "src/assets/css/common.scss";
</style>



// WEBPACK FOOTER //
// List.vue?21973a01